var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[(_vm.label)?_c('label',[_vm._v(_vm._s(_vm.label)+" "),_vm._t("default")],2):_vm._t("default"),(_vm.error)?_c('div',{staticClass:"error",domProps:{"textContent":_vm._s(_vm.error[0])}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }